import PATHS from '../constants';

function fetchProjects() {
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };
    return fetch(PATHS.PROJECTS, {
        method: 'GET',
        dataType: 'json',
        headers,
    });
};

export default fetchProjects;